module.exports = __webpack_public_path__ + "media/images/color_admin_v3/user-14-89f4eb5f060d639908bc7324a48b8fed.jpg";